import { isUndefined, isEmpty } from "lodash";

export const getElementsProperty = (className, cb) => {
  let elements = document.querySelectorAll(`.${className}`);

  if (!isEmpty(elements)) {
    for (let element of elements) {
      let props = {};
      if (!isUndefined(element.dataset.items)) {
        props.items = JSON.parse(element.dataset.items, _reviver);
      }
      if (!isUndefined(element.dataset.endpoint)) {
        props.endpoint = element.dataset.endpoint;
      }
      if (!isUndefined(element.dataset.type)) {
        props.type = element.dataset.type;
      }
      if (!isUndefined(element.dataset.params)) {
        props.params = JSON.parse(element.dataset.params, _reviver);
      }
      if (!isUndefined(element.dataset.id)) {
        props.id = element.dataset.id;
      }
      if (!isUndefined(element.dataset.url)) {
        props.url = element.dataset.url;
      }
      if (!isUndefined(element.dataset.symbol)) {
        props.symbol = element.dataset.symbol;
      }
      if (!isUndefined(element.dataset.symbolIndex)) {
        props.symbolIndex = element.dataset.symbolIndex;
      }
      if (!isUndefined(element.dataset.symbols)) {
        props.symbol = JSON.parse(element.dataset.symbols, _reviver);
      }

      if (Object.keys(props).length > 0) {
        cb(props, element);
      } else {
        console.error("This element don't have any property!");
      }
    }
  }
};

/**
 * @see https://mariusschulz.com/blog/deserializing-json-strings-as-javascript-date-objects
 * @param {*} key
 * @param {*} value
 */
function _reviver(key, value) {
  const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
  if (typeof value === "string" && dateFormat.test(value)) {
    return new Date(value);
  }
  return value;
}
